var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
var Header = (function (_super) {
    __extends(Header, _super);
    function Header() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Header.prototype.render = function () {
        return (React.createElement("div", { className: "s20-header-sticky js-stickybox", "data-has-module": "yes" },
            React.createElement("header", { className: "js-header-s20 s20-header s20-header--mini" },
                React.createElement("div", { className: "s20-header__main" },
                    React.createElement("div", { className: "js-stickybox-element-s20 s20-header__navigation" },
                        React.createElement("div", { className: "s20-header__inner" },
                            React.createElement("div", { className: "s20-header__container" },
                                React.createElement("div", { className: "s20-header__logo" },
                                    React.createElement("a", { className: "s20-header__logo-link", href: "/en/residential/welcome-page.html" },
                                        React.createElement("img", { alt: "Logo Sunrise", className: "s20-header__logo-img", src: "/img/icons_s20/sunrise_logo.svg" }))))))))));
    };
    return Header;
}(React.Component));
export { Header };
